class ProductionRecord {
  constructor(data, config) {
    this.typeOfDocument   = data.type_of_document
    this.source           = data.source
    this.sourceUrl        = data.source_url
    this.state            = data.state
    this.county           = data.county
    this.operator         = data.operator
    this.operatorCodes    = data.operator_codes
    this.wellName         = data.well_name
    this.apiNumber        = data.api_number
    this.leaseName        = data.lease_name
    this.leaseNumber      = data.lease_number
    this.leaseId          = data.lease_unit_id
    this.firstProdDate    = data.first_prod_date
    this.firstMonthOilVol = data.first_month_oil_vol
    this.firstMonthGasVol = data.first_month_gas_vol
    this.lastProdDate     = data.last_prod_date
    this.lastMonthOilVol  = data.last_month_oil_vol
    this.lastMonthGasVol  = data.last_month_gas_vol
    this.wellStatus       = data.last_prod_date
    this.cumulativeOil    = data.cumulative_oil
    this.cumulativeGas    = data.cumulative_gas
    this.cumulativeWater  = data.cumulative_water
    this.cumulativeYear   = data.cumulative_year_reported
    this.survey           = data.survey
    this.abstr            = data.abstr
    this.legal            = data.legal
  }
}

export default ProductionRecord
